export default __webpack_public_path__ + "static/media/marketing-banner.6bab997c.png";